import { styled, Box } from '@mui/material';

export const WageIndexationHalfGridContainer = styled(Box)(({ theme }) => ({
  width: '49.5%',
  marginTop: theme.spacing(3),
  height: '55vh',
  '& .Mui-error': {
    color: theme.palette.error.main,
  },
}));

export const WageIndexationGridContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  height: '55vh',
  '& .Mui-error': {
    color: theme.palette.error.main,
  },
}));

export const ConfirmButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  marginTop: theme.spacing(2),
}));

export const CompanyWageIndexationGridContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(8),
  height: '55vh',
  '& .Mui-error': {
    color: theme.palette.error.main,
  },
}));

export const IndexationFilterContainer = styled(Box)(() => ({
  background: 'white',
  padding: '10px 32px 10px 32px',
  marginTop: '10px',
  borderRadius: '8px',
  boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
  maxHeight: 'auto',
}));

export const IndexationFlowContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  height: '90vh',
}));

export const WageIndexationFlowButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '20px',
  padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
  marginLeft: 'auto',
}));

export const WageIndexationFlowStepContainer = styled(Box)<{ activeStep?: number }>(({ theme, activeStep }) => ({
  width: '100%',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  // padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  marginTop: theme.spacing(1),
  transition: 'transform 0.75s ease-in-out',
  transform: `translateY(${activeStep * -80}vh)`,
}));

export const WageIndexationFlowCard = styled(Box)(({ theme }) => ({
  width: '100%',
  borderRadius: '4px',
  backgroundColor: 'white',
  padding: theme.spacing(2.5),
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  maxHeight: '800px',
  overflowY: 'auto',
}));
